import { rem } from 'polished'

// function which returns a multiplier on the default spacing of 4px
export default (multiplier = 1) => {
  let spacing

  var funcs = {
    get() {
      spacing = 4 * multiplier
      return spacing
    },
    px() {
      return `${spacing}px`
    },
    rem() {
      return rem(this.px(spacing))
    }
  }

  spacing = funcs.get(multiplier)
  return funcs
}
